export const PAGE_SIZE = 20;
export const ROW_HEIGHT = 70;

export const CONTAINER_DEPOSIT_OPTIONS = [
  { label: "Container Deposit(s) $0.00", value: "D00000" },
  { label: "Container Deposit(s) $0.10", value: "D00010" },
  { label: "Container Deposit(s) $0.20", value: "D00020" },
  { label: "Container Deposit(s) $0.25", value: "D00025" },
  { label: "Container Deposit(s) $0.30", value: "D00030" },
  { label: "Container Deposit(s) $0.35", value: "D00035" },
  { label: "Container Deposit(s) $0.40", value: "D00040" },
  { label: "Container Deposit(s) $0.50", value: "D00050" },
  { label: "Container Deposit(s) $0.60", value: "D00060" },
  { label: "Container Deposit(s) $0.70", value: "D00070" },
  { label: "Container Deposit(s) $0.75", value: "D00075" },
  { label: "Container Deposit(s) $0.80", value: "D00080" },
  { label: "Container Deposit(s) $0.85", value: "D00085" },
  { label: "Container Deposit(s) $0.90", value: "D00090" },
  { label: "Container Deposit(s) $1.00", value: "D00100" },
  { label: "Container Deposit(s) $1.10", value: "D00110" },
  { label: "Container Deposit(s) $1.20", value: "D00120" },
  { label: "Container Deposit(s) $1.30", value: "D00130" },
  { label: "Container Deposit(s) $1.40", value: "D00140" },
  { label: "Container Deposit(s) $1.50", value: "D00150" },
  { label: "Container Deposit(s) $1.60", value: "D00160" },
  { label: "Container Deposit(s) $1.70", value: "D00170" },
  { label: "Container Deposit(s) $1.80", value: "D00180" },
  { label: "Container Deposit(s) $1.90", value: "D00190" },
  { label: "Container Deposit(s) $2.00", value: "D00200" },
  { label: "Container Deposit(s) $2.10", value: "D00210" },
  { label: "Container Deposit(s) $2.20", value: "D00220" },
  { label: "Container Deposit(s) $2.30", value: "D00230" },
  { label: "Container Deposit(s) $2.40", value: "D00240" },
  { label: "Container Deposit(s) $2.50", value: "D00250" },
  { label: "Container Deposit(s) $2.60", value: "D00260" },
  { label: "Container Deposit(s) $2.70", value: "D00270" },
  { label: "Container Deposit(s) $2.80", value: "D00280" },
  { label: "Container Deposit(s) $2.90", value: "D00290" },
  { label: "Container Deposit(s) $3.00", value: "D00300" },
  { label: "Container Deposit(s) $3.10", value: "D00310" },
  { label: "Container Deposit(s) $3.20", value: "D00320" },
  { label: "Container Deposit(s) $3.30", value: "D00330" },
  { label: "Container Deposit(s) $3.40", value: "D00340" },
  { label: "Container Deposit(s) $3.50", value: "D00350" },
  { label: "Container Deposit(s) $3.60", value: "D00360" },
  { label: "Container Deposit(s) $4.10", value: "D00410" },
  { label: "Container Deposit(s) $4.80", value: "D00480" },
  { label: "Container Deposit(s) $6.00", value: "D00600" },
  { label: "Container Deposit(s) $30.00", value: "D03000" },
  { label: "Container Deposit(s) $37.00", value: "D03700" },
];

// CATEGORY (Type Level)
export const TYPE_OPTIONS = [
  { label: "Wine", value: "Wine" },
  { label: "Spirits", value: "Spirits" },
  { label: "Sparkling", value: "Sparkling" },
  { label: "Liqueurs", value: "Liqueurs" },
  { label: "Asian Beverages", value: "Asian Beverages" },
  { label: "Beer", value: "Beer" },
  { label: "Keg", value: "Keg" },
  { label: "Zero & Low Alcohol", value: "Zero & Low Alcohol" },
  { label: "Ready-to-Drink Cocktails", value: "Ready-to-Drink Cocktails" },
  { label: "Cider", value: "Cider" },
  { label: "Wine Cocktails", value: "Wine Cocktails" },
  { label: "Soft Drinks & Mixers", value: "Soft Drinks & Mixers" },
  { label: "Pre-Mixed Cocktails", value: "Pre-Mixed Cocktails" },
  { label: "Aperitif & Digestif", value: "Aperitif & Digestif" },
];


// TYPE (Subtype Level)
export const SUBTYPE_OPTIONS = {
  Wine: [
    { label: "Red", value: "Red" },
    { label: "White", value: "White" },
    { label: "Rose", value: "Rose" },
    { label: "Dessert", value: "Dessert" },
    { label: "Fortified", value: "Fortified" },
  ],
  Sparkling: [
    { label: "Sparkling White", value: "Sparkling White" },
    { label: "Sparkling Rose", value: "Sparkling Rose" },
    { label: "Sparkling Red", value: "Sparkling Red" },
    { label: "Champagne Only", value: "Champagne Only" },
  ],
  Spirits: [
    { label: "Whisky", value: "Whisky" },
    { label: "Tequila", value: "Tequila" },
    { label: "Rum", value: "Rum" },
    { label: "Vodka", value: "Vodka" },
    { label: "Gin", value: "Gin" },
    { label: "Cognac", value: "Cognac" },
    { label: "Brandy", value: "Brandy" },
    { label: "Mezcal", value: "Mezcal" },
    { label: "Grappa", value: "Grappa" },
    { label: "Armagnac", value: "Armagnac" },
    { label: "Other Spirits", value: "Other Spirits" },
  ],
  Liqueurs: [
    { label: "Anise", value: "Anise" },
    { label: "Aperitif & Digestif", value: "Aperitif & Digestif" },
    { label: "Bitters & Herbs", value: "Bitters & Herbs" },
    { label: "Cream & Sweet", value: "Cream & Sweet" },
    { label: "Floral", value: "Floral" },
    { label: "Fruit Flavoured", value: "Fruit Flavoured" },
    { label: "Nut & Coffee", value: "Nut & Coffee" },
    { label: "Pre Mixed", value: "Pre Mixed" },
  ],
  Beer: [
    { label: "Lager & Pilsner", value: "Lager & Pilsner" },
    { label: "Ales", value: "Ales" },
    { label: "IPAs", value: "IPAs" },
    { label: "Porter & Stout", value: "Porter & Stout" },
    { label: "Sour & Wilds", value: "Sour & Wilds" },
    { label: "Wheat", value: "Wheat" },
    { label: "Strong Ales", value: "Strong Ales" },
  ],
  Keg: [
    { label: "Lager & Pilsner", value: "Lager & Pilsner" },
    { label: "Ales", value: "Ales" },
    { label: "IPAs", value: "IPAs" },
    { label: "Porter & Stout", value: "Porter & Stout" },
    { label: "Sour & Wilds", value: "Sour & Wilds" },
    { label: "Wheat", value: "Wheat" },
    { label: "Strong Ales", value: "Strong Ales" },
  ],
  "Asian Beverages": [
    { label: "Sake", value: "Sake" },
    { label: "Infused Sake & Cocktail", value: "Infused Sake & Cocktail" },
    { label: "Umeshu", value: "Umeshu" },
    { label: "Shochu & Awamori", value: "Shochu & Awamori" },
    { label: "Moutai & Other Baijiu", value: "Moutai & Other Baijiu" },
  ],
  "Ready-to-Drink Cocktails": [
    { label: "Dry Coolers", value: "Dry Coolers" },
    { label: "Premixed Coolers", value: "Premixed Coolers" },
    { label: "Sweet Coolers", value: "Sweet Coolers" },
    { label: "Wine Based Coolers", value: "Wine Based Coolers" },
    { label: "Fruity & Sour", value: "Fruity & Sour" },
    { label: "Easy Drinking", value: "Easy Drinking" },
  ],
  Cider: [],
  "Zero & Low Alcohol": [
    { label: "Alcohol-Free Wine", value: "Alcohol-Free Wine" },
    { label: "Alcohol-Free Beer", value: "Alcohol-Free Beer" },
    { label: "Alcohol-Free Spirits", value: "Alcohol-Free Spirits" },
    { label: "Low Alcohol", value: "Low Alcohol" },
  ],
};

// VARIETAL (Subsubtype Level)
export const SUBSUBTYPE_OPTIONS = {
  Red: [
    { label: "Aglianico", value: "Aglianico" },
    { label: "Alvarelhao", value: "Alvarelhao" },
    { label: "Baco Noir", value: "Baco Noir" },
    { label: "Baga", value: "Baga" },
    { label: "Barbera", value: "Barbera" },
    { label: "Blaufrankisch", value: "Blaufrankisch" },
    { label: "Bonarda", value: "Bonarda" },
    { label: "Bracheto", value: "Bracheto" },
    { label: "Cabernet Franc", value: "Cabernet Franc" },
    { label: "Cabernet Sauvignon", value: "Cabernet Sauvignon" },
    { label: "Canaiolo", value: "Canaiolo" },
    { label: "Cannonau", value: "Cannonau" },
    { label: "Carignan", value: "Carignan" },
    { label: "Carmenere", value: "Carmenere" },
    { label: "Cinsault", value: "Cinsault" },
    { label: "Counoise", value: "Counoise" },
    { label: "Corvina", value: "Corvina" },
    { label: "Crljenak", value: "Crljenak" },
    { label: "Dolcetto", value: "Dolcetto" },
    { label: "Frappato", value: "Frappato" },
    { label: "Gaglioppo", value: "Gaglioppo" },
    { label: "Gamay", value: "Gamay" },
    { label: "Gamay Noir", value: "Gamay Noir" },
    { label: "Graciano", value: "Graciano" },
    { label: "Grenache", value: "Grenache" },
    { label: "Grolleau", value: "Grolleau" },
    { label: "Lagrein", value: "Lagrein" },
    { label: "Lambrusco", value: "Lambrusco" },
    { label: "Lambrusco Salamino", value: "Lambrusco Salamino" },
    { label: "Lemberger", value: "Lemberger" },
    { label: "Malbec", value: "Malbec" },
    { label: "Mencia", value: "Mencia" },
    { label: "Merlot", value: "Merlot" },
    { label: "Monastrell", value: "Monastrell" },
    { label: "Montepulciano", value: "Montepulciano" },
    { label: "Mourvedre", value: "Mourvedre" },
    { label: "Nebbiolo", value: "Nebbiolo" },
    { label: "Negroamaro", value: "Negroamaro" },
    { label: "Nerello Mascalese", value: "Nerello Mascalese" },
    { label: "Nero d'Avola", value: "Nero d'Avola" },
    { label: "Odeskyi Chornyi", value: "Odeskyi Chornyi" },
    { label: "Oseleta", value: "Oseleta" },
    { label: "Pais", value: "Pais" },
    { label: "Pelaverga Piccolo", value: "Pelaverga Piccolo" },
    { label: "Petit Verdot", value: "Petit Verdot" },
    { label: "Petite Sirah", value: "Petite Sirah" },
    { label: "Pineau D'Aunis", value: "Pineau D'Aunis" },
    { label: "Pinot Noir", value: "Pinot Noir" },
    { label: "Pinotage", value: "Pinotage" },
    { label: "Plavac Mali", value: "Plavac Mali" },
    { label: "Primitivo", value: "Primitivo" },
    { label: "Recantina", value: "Recantina" },
    { label: "Red Wine Blend", value: "Red Wine Blend" },
    { label: "Refosco", value: "Refosco" },
    { label: "Sagrantino", value: "Sagrantino" },
    { label: "Sangiovese", value: "Sangiovese" },
    { label: "Saperavi", value: "Saperavi" },
    { label: "Shiraz", value: "Shiraz" },
    { label: "St Laurent", value: "St Laurent" },
    { label: "Syrah", value: "Syrah" },
    { label: "Tannat", value: "Tannat" },
    { label: "Tempranillo", value: "Tempranillo" },
    { label: "Teroldego", value: "Teroldego" },
    { label: "Tibouren", value: "Tibouren" },
    { label: "Tinta de Toro", value: "Tinta de Toro" },
    { label: "Touriga Nacional", value: "Touriga Nacional" },
    { label: "Trousseau", value: "Trousseau" },
    { label: "Valdiguie", value: "Valdiguie" },
    { label: "Valpolicella", value: "Valpolicella" },
    { label: "Zinfandel", value: "Zinfandel" },
    { label: "Zweigelt", value: "Zweigelt" },
  ],
  White: [
    { label: "Airen", value: "Airen" },
    { label: "Aligote", value: "Aligote" },
    { label: "Albarino", value: "Albarino" },
    { label: "Arneis", value: "Arneis" },
    { label: "Assyrtiko", value: "Assyrtiko" },
    { label: "Bellone", value: "Bellone" },
    { label: "Bombino Bianco", value: "Bombino Bianco" },
    { label: "Carricante", value: "Carricante" },
    { label: "Catarratto", value: "Catarratto" },
    { label: "Chardonnay", value: "Chardonnay" },
    { label: "Chenin Blanc", value: "Chenin Blanc" },
    { label: "Cortese", value: "Cortese" },
    { label: "Daiginjo", value: "Daiginjo" },
    { label: "Ehrenfelser", value: "Ehrenfelser" },
    { label: "Erbaluce", value: "Erbaluce" },
    { label: "Falanghina", value: "Falanghina" },
    { label: "Favorita", value: "Favorita" },
    { label: "Fiano", value: "Fiano" },
    { label: "Friulano", value: "Friulano" },
    { label: "Furmint", value: "Furmint" },
    { label: "Garganega", value: "Garganega" },
    { label: "Genshu", value: "Genshu" },
    { label: "Gewurztraminer", value: "Gewurztraminer" },
    { label: "Ginjo", value: "Ginjo" },
    { label: "Gruner Veltliner", value: "Gruner Veltliner" },
    { label: "Greco Bianco", value: "Greco Bianco" },
    { label: "Grenache Blanc", value: "Grenache Blanc" },
    { label: "Grillo", value: "Grillo" },
    { label: "Honjozo", value: "Honjozo" },
    { label: "Junmai", value: "Junmai" },
    { label: "Junmai Daiginjo", value: "Junmai Daiginjo" },
    { label: "Junmai Ginjo", value: "Junmai Ginjo" },
    { label: "Kerner", value: "Kerner" },
    { label: "Loureiro", value: "Loureiro" },
    { label: "Macabeo", value: "Macabeo" },
    { label: "Malvasia", value: "Malvasia" },
    { label: "Malvar", value: "Malvar" },
    { label: "Manzoni Bianco", value: "Manzoni Bianco" },
    { label: "Marsanne", value: "Marsanne" },
    { label: "Melon de Bourgogne", value: "Melon de Bourgogne" },
    { label: "Moscato", value: "Moscato" },
    { label: "Muscadet", value: "Muscadet" },
    { label: "Muscat", value: "Muscat" },
    { label: "Muscat of Alexandria", value: "Muscat of Alexandria" },
    { label: "Nascetta", value: "Nascetta" },
    { label: "Nosiola", value: "Nosiola" },
    { label: "Ortega", value: "Ortega" },
    { label: "Passerina", value: "Passerina" },
    { label: "Pedro Ximenez", value: "Pedro Ximenez" },
    { label: "Pecorino", value: "Pecorino" },
    { label: "Petit Manseng", value: "Petit Manseng" },
    { label: "Picpoul", value: "Picpoul" },
    { label: "Pinot Auxerrois", value: "Pinot Auxerrois" },
    { label: "Pinot Blanc", value: "Pinot Blanc" },
    { label: "Pinot Gris", value: "Pinot Gris" },
    { label: "Pinot Grigio", value: "Pinot Grigio" },
    { label: "Prosecco", value: "Prosecco" },
    { label: "Recioto", value: "Recioto" },
    { label: "Ribolla Gialla", value: "Ribolla Gialla" },
    { label: "Riesling", value: "Riesling" },
    { label: "Rotgipfler", value: "Rotgipfler" },
    { label: "Roussanne", value: "Roussanne" },
    { label: "Sauvignon Blanc", value: "Sauvignon Blanc" },
    { label: "Semillon", value: "Semillon" },
    { label: "Torrontes", value: "Torrontes" },
    { label: "Trebbiano", value: "Trebbiano" },
    { label: "Turbiana", value: "Turbiana" },
    { label: "Verdejo", value: "Verdejo" },
    { label: "Vermentino", value: "Vermentino" },
    { label: "Verdicchio", value: "Verdicchio" },
    { label: "Vernaccia", value: "Vernaccia" },
    { label: "Vespaiolo", value: "Vespaiolo" },
    { label: "Vidal", value: "Vidal" },
    { label: "Viognier", value: "Viognier" },
    { label: "Weissburgunder", value: "Weissburgunder" },
    { label: "White Malbec", value: "White Malbec" },
    { label: "White Wine Blend", value: "White Wine Blend" },
  ],
  Whisky: [
    { label: "Blended Whisky", value: "Blended Whisky" },
    { label: "Bourbon", value: "Bourbon" },
    { label: "Flavoured Whisky", value: "Flavoured Whisky" },
    { label: "Other Whisky", value: "Other Whisky" },
    { label: "Rye Whisky", value: "Rye Whisky" },
    { label: "Single Malt", value: "Single Malt" },
  ],
    Fortified: [
    { label: "Port & Similar", value: "Port & Similar" },
    { label: "Sherry & Similar", value: "Sherry & Similar" },
    { label: "Madeira & Similar", value: "Madeira & Similar" },
    { label: "Vermouth & Aperitif", value: "Vermouth & Aperitif" },
    { label: "Marsala & Similar", value: "Marsala & Similar" },
  ],
  Tequila: [
    { label: "Anejo", value: "Anejo" },
    { label: "Blanco", value: "Blanco" },
    { label: "Cristalino", value: "Cristalino" },
    { label: "Extra Anejo", value: "Extra Anejo" },
    { label: "Flavoured", value: "Flavoured" },
    { label: "Joven", value: "Joven" },
    { label: "Reposado", value: "Reposado" },
  ],
  Cognac: [
    { label: "Specialty Cognac", value: "Specialty Cognac" },
    { label: "VS", value: "VS" },
    { label: "VSOP", value: "VSOP" },
    { label: "XO", value: "XO" },
  ],
  "Champagne Only": [
    { label: "Extra Brut (Driest)", value: "Extra Brut (Driest)" },
    { label: "Brut (Dry)", value: "Brut (Dry)" },
    { label: "Extra Dry (Medium)", value: "Extra Dry (Medium)" },
    { label: "Demi Sec (Sweet)", value: "Demi Sec (Sweet)" },
    { label: "Sec (Medium Sweet)", value: "Sec (Medium Sweet)" },
    { label: "Doux (Very Sweet)", value: "Doux (Very Sweet)" },
  ],
  "Sparkling Red": [
    { label: "Extra Brut (Driest)", value: "Extra Brut (Driest)" },
    { label: "Brut (Dry)", value: "Brut (Dry)" },
    { label: "Extra Dry (Medium)", value: "Extra Dry (Medium)" },
    { label: "Demi Sec (Sweet)", value: "Demi Sec (Sweet)" },
    { label: "Sec (Medium Sweet)", value: "Sec (Medium Sweet)" },
    { label: "Doux (Very Sweet)", value: "Doux (Very Sweet)" },
  ],
  "Sparkling Rose": [
    { label: "Extra Brut (Driest)", value: "Extra Brut (Driest)" },
    { label: "Brut (Dry)", value: "Brut (Dry)" },
    { label: "Extra Dry (Medium)", value: "Extra Dry (Medium)" },
    { label: "Demi Sec (Sweet)", value: "Demi Sec (Sweet)" },
    { label: "Sec (Medium Sweet)", value: "Sec (Medium Sweet)" },
    { label: "Doux (Very Sweet)", value: "Doux (Very Sweet)" },
  ],
  "Sparkling White": [
    { label: "Extra Brut (Driest)", value: "Extra Brut (Driest)" },
    { label: "Brut (Dry)", value: "Brut (Dry)" },
    { label: "Extra Dry (Medium)", value: "Extra Dry (Medium)" },
    { label: "Demi Sec (Sweet)", value: "Demi Sec (Sweet)" },
    { label: "Sec (Medium Sweet)", value: "Sec (Medium Sweet)" },
    { label: "Doux (Very Sweet)", value: "Doux (Very Sweet)" },
  ],
  Sake: [
    { label: "Daiginjo", value: "Daiginjo" },
    { label: "Genshu", value: "Genshu" },
    { label: "Ginjo", value: "Ginjo" },
    { label: "Honjozo", value: "Honjozo" },
    { label: "Junmai", value: "Junmai" },
    { label: "Junmai Daiginjo", value: "Junmai Daiginjo" },
    { label: "Junmai Ginjo", value: "Junmai Ginjo" },
    { label: "Kimoto + Yamahai", value: "Kimoto + Yamahai" },
    { label: "Koshu", value: "Koshu" },
    { label: "Namazake", value: "Namazake" },
    { label: "Nigori", value: "Nigori" },
  ],
  Brandy: [
    { label: "VSOP", value: "VSOP" },
    { label: "XO", value: "XO" },
  ],
  "Other Spirits": [
    { label: "Cachaca", value: "Cachaca" },
    { label: "Aquavit", value: "Aquavit" },
  ],
  "Lager & Pilsner": [
    { label: "Pilsner", value: "Pilsner" },
    { label: "Pale Lager", value: "Pale Lager" },
    { label: "Amber Lager", value: "Amber Lager" },
    { label: "Dark Lager", value: "Dark Lager" },
  ],
  Ales: [
    { label: "Pale Ale", value: "Pale Ale" },
    { label: "Hazy Pale Ale", value: "Hazy Pale Ale" },
    { label: "Amber & Red Ale", value: "Amber & Red Ale" },
    { label: "Blonde Ale", value: "Blonde Ale" },
    { label: "Dark Ale", value: "Dark Ale" },
    { label: "Brown Ale", value: "Brown Ale" },
    { label: "Session Ale", value: "Session Ale" },
    { label: "Farmhouse / Saison Ale", value: "Farmhouse / Saison Ale" },
  ],
  IPAs: [
    { label: "West Coast IPA", value: "West Coast IPA" },
    { label: "New England IPA", value: "New England IPA" },
    { label: "Hazy IPA", value: "Hazy IPA" },
    { label: "Double / Imperial IPA", value: "Double / Imperial IPA" },
    { label: "Session IPA", value: "Session IPA" },
    { label: "Black IPA", value: "Black IPA" },
    { label: "White IPA", value: "White IPA" },
    { label: "Red IPA", value: "Red IPA" },
  ],
  "Porter & Stout": [
    { label: "American Porter", value: "American Porter" },
    { label: "Irish Stout", value: "Irish Stout" },
    { label: "Milk Stout", value: "Milk Stout" },
    { label: "Oatmeal Stout", value: "Oatmeal Stout" },
    { label: "Imperial Stout", value: "Imperial Stout" },
  ],
  "Sour & Wilds": [
    { label: "Gose", value: "Gose" },
    { label: "Sour Ale", value: "Sour Ale" },
    { label: "Sour IPA", value: "Sour IPA" },
    { label: "Wild Ale", value: "Wild Ale" },
  ],
  Wheat: [
    { label: "Hefeweizen", value: "Hefeweizen" },
    { label: "Witbier", value: "Witbier" },
  ],
  "Strong Ales": [
    { label: "Belgian Dubbel", value: "Belgian Dubbel" },
    { label: "Belgian Tripel", value: "Belgian Tripel" },
    { label: "Belgian Strong Golden Ale", value: "Belgian Strong Golden Ale" },
  ],
};

export const SIZE_OPTIONS = [
  { label: "30 ml", value: "30" },
  { label: "50 ml", value: "50" },
  { label: "100 ml", value: "100" },
  { label: "180 ml", value: "180" },
  { label: "187 ml", value: "187" },
  { label: "200 ml", value: "200" },
  { label: "207 ml", value: "207" },
  { label: "222 ml", value: "222" },
  { label: "237 ml", value: "237" },
  { label: "250 ml", value: "250" },
  { label: "284 ml", value: "284" },
  { label: "290 ml", value: "290" },
  { label: "295 ml", value: "295" },
  { label: "300 ml", value: "300" },
  { label: "330 ml", value: "330" },
  { label: "333 ml", value: "333" },
  { label: "341 ml", value: "341" },
  { label: "350 ml", value: "350" },
  { label: "355 ml", value: "355" },
  { label: "360 ml", value: "360" },
  { label: "375 ml", value: "375" },
  { label: "440 ml", value: "440" },
  { label: "450 ml", value: "450" },
  { label: "458 ml", value: "458" },
  { label: "460 ml", value: "460" },
  { label: "473 ml", value: "473" },
  { label: "480 ml", value: "480" },
  { label: "500 ml", value: "500" },
  { label: "550 ml", value: "550" },
  { label: "600 ml", value: "600" },
  { label: "650 ml", value: "650" },
  { label: "660 ml", value: "660" },
  { label: "700 ml", value: "700" },
  { label: "710 ml", value: "710" },
  { label: "720 ml", value: "720" },
  { label: "740 ml", value: "740" },
  { label: "750 ml", value: "750" },
  { label: "900 ml", value: "900" },
  { label: "1 L", value: "1000" },
  { label: "1.14 L", value: "1140" },
  { label: "1.5 L", value: "1500" },
  { label: "1.75 L", value: "1750" },
  { label: "1.8 L", value: "1800" },
  { label: "2 L", value: "2000" },
  { label: "2.5 L", value: "2500" },
  { label: "3 L", value: "3000" },
  { label: "4 L", value: "4000" },
  { label: "4.5 L", value: "4500" },
  { label: "5 L", value: "5000" },
  { label: "6 L", value: "6000" },
  { label: "9 L", value: "9000" },
  { label: "16 L", value: "16000" },
  { label: "18 L", value: "18000" },
  { label: "18.5 L", value: "18500" },
  { label: "20 L", value: "20000" },
  { label: "30 L", value: "30000" },
  { label: "50 L", value: "50000" },
  { label: "59 L", value: "59000" },
];

export const PRESENTATION_OPTIONS = [
  { label: "Single", value: "Single" },
  { label: "2 Pack", value: "2 Pack" },
  { label: "3 Pack", value: "3 Pack" },
  { label: "4 Pack", value: "4 Pack" },
  { label: "5 Pack", value: "5 Pack" },
  { label: "6 Pack", value: "6 Pack" },
  { label: "7 Pack", value: "7 Pack" },
  { label: "8 Pack", value: "8 Pack" },
  { label: "9 Pack", value: "9 Pack" },
  { label: "12 Pack", value: "12 Pack" },
  { label: "15 Pack", value: "15 Pack" },
  { label: "18 Pack", value: "18 Pack" },
  { label: "20 Pack", value: "20 Pack" },
  { label: "24 Pack", value: "24 Pack" },
  { label: "30 Pack", value: "30 Pack" },
  { label: "36 Pack", value: "36 Pack" },
  { label: "48 Pack", value: "48 Pack" },
];

export const CONTAINER_OPTIONS = [
  { label: "Bottle", value: "Bottle" },
  { label: "Box", value: "Box" },
  { label: "Can", value: "Can" },
  { label: "Keg", value: "Keg" },
];

export const COUNTRY_OPTIONS = [
  { label: "Argentina", value: "Argentina" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Barbados", value: "Barbados" },
  { label: "Belgium", value: "Belgium" },
  { label: "Belize", value: "Belize" },
  { label: "Bermuda", value: "Bermuda" },
  { label: "Brazil", value: "Brazil" },
  { label: "Bulgaria", value: "Bulgaria" },
  { label: "Canada", value: "Canada" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Colombia", value: "Colombia" },
  { label: "Croatia", value: "Croatia" },
  { label: "Cuba", value: "Cuba" },
  { label: "Czech Republic", value: "Czech Republic" },
  { label: "Denmark", value: "Denmark" },
  { label: "Dominican Republic", value: "Dominican Republic" },
  { label: "England", value: "England" },
  { label: "Fiji", value: "Fiji" },
  { label: "Finland", value: "Finland" },
  { label: "France", value: "France" },
  { label: "Georgia", value: "Georgia" },
  { label: "Germany", value: "Germany" },
  { label: "Greece", value: "Greece" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Guyana", value: "Guyana" },
  { label: "Haiti", value: "Haiti" },
  { label: "Hungary", value: "Hungary" },
  { label: "Iceland", value: "Iceland" },
  { label: "India", value: "India" },
  { label: "Ireland", value: "Ireland" },
  { label: "Israel", value: "Israel" },
  { label: "Italy", value: "Italy" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Japan", value: "Japan" },
  { label: "Korea", value: "Korea" },
  { label: "Latvia", value: "Latvia" },
  { label: "Lebanon", value: "Lebanon" },
  { label: "Lithuania", value: "Lithuania" },
  { label: "Luxembourg", value: "Luxembourg" },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Martinique", value: "Martinique" },
  { label: "Mexico", value: "Mexico" },
  { label: "Moldova", value: "Moldova" },
  { label: "Montenegro", value: "Montenegro" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "New Zealand", value: "New Zealand" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Norway", value: "Norway" },
  { label: "Panama", value: "Panama" },
  { label: "Peru", value: "Peru" },
  { label: "Philippines", value: "Philippines" },
  { label: "Poland", value: "Poland" },
  { label: "Portugal", value: "Portugal" },
  { label: "Puerto Rico", value: "Puerto Rico" },
  { label: "Romania", value: "Romania" },
  { label: "Saint Lucia", value: "Saint Lucia" },
  { label: "Scotland", value: "Scotland" },
  { label: "Serbia", value: "Serbia" },
  { label: "Singapore", value: "Singapore" },
  { label: "Slovenia", value: "Slovenia" },
  { label: "South Africa", value: "South Africa" },
  { label: "Spain", value: "Spain" },
  { label: "Sweden", value: "Sweden" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Taiwan", value: "Taiwan" },
  { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
  { label: "Ukraine", value: "Ukraine" },
  { label: "United States", value: "United States" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Wales", value: "Wales" },
];

export const REGION_OPTIONS = {
  Argentina: [
    { label: "La Rioja", value: "La Rioja" },
    { label: "Mendoza", value: "Mendoza" },
    { label: "Patagonia", value: "Patagonia" },
    { label: "Rio Negro", value: "Rio Negro" },
    { label: "Salta", value: "Salta" },
    { label: "San Juan", value: "San Juan" },
  ],
  Australia: [
    { label: "New South Wales", value: "New South Wales" },
    { label: "Queensland", value: "Queensland" },
    { label: "South Australia", value: "South Australia" },
    { label: "South Eastern Australia", value: "South Eastern Australia" },
    { label: "Tasmania", value: "Tasmania" },
    { label: "Victoria", value: "Victoria" },
    { label: "Western Australia", value: "Western Australia" },
  ],
  Austria: [
    { label: "Burgenland", value: "Burgenland" },
    { label: "Niederosterreich", value: "Niederosterreich" },
    { label: "Salzburg", value: "Salzburg" },
    { label: "Vienna", value: "Vienna" },
    { label: "Wachau", value: "Wachau" },
  ],
  Canada: [
    { label: "Alberta", value: "Alberta" },
    { label: "British Columbia", value: "British Columbia" },
    { label: "New Brunswick", value: "New Brunswick" },
    { label: "Newfoundland", value: "Newfoundland" },
    { label: "Nova Scotia", value: "Nova Scotia" },
    { label: "Ontario", value: "Ontario" },
    { label: "Quebec", value: "Quebec" },
    { label: "Saskatchewan", value: "Saskatchewan" },
    { label: "Yukon", value: "Yukon" },
  ],
    Chile: [
    { label: "Aconcagua", value: "Aconcagua" },
    { label: "Aconcagua Valley", value: "Aconcagua Valley" },
    { label: "Casablanca Valley", value: "Casablanca Valley" },
    { label: "Central Valley", value: "Central Valley" },
    { label: "Colchagua", value: "Colchagua" },
    { label: "Coquimbo", value: "Coquimbo" },
    { label: "Elqui Valley", value: "Elqui Valley" },
    { label: "Itata Valley", value: "Itata Valley" },
    { label: "Limari Valley", value: "Limari Valley" },
    { label: "Maipo Valley", value: "Maipo Valley" },
    { label: "Malleco Valley", value: "Malleco Valley" },
  ],
  China: [
    { label: "Guizhou", value: "Guizhou" },
  ],
  Germany: [
    { label: "Hamburg", value: "Hamburg" },
    { label: "Mosel", value: "Mosel" },
    { label: "Nahe", value: "Nahe" },
    { label: "Pfalz", value: "Pfalz" },
    { label: "Rheingau", value: "Rheingau" },
    { label: "Rheinhessen", value: "Rheinhessen" },
    { label: "Sachsen", value: "Sachsen" },
    { label: "Wurttemberg", value: "Wurttemberg" },
  ],
   Greece: [
    { label: "Macedonia", value: "Macedonia" },
  ],
   France: [
    { label: "Alsace", value: "Alsace" },
    { label: "Bergerac", value: "Bergerac" },
    { label: "Bordeaux", value: "Bordeaux" },
    { label: "Brittany", value: "Brittany" },
    { label: "Burgundy", value: "Burgundy" },
    { label: "Cahors", value: "Cahors" },
    { label: "Champagne", value: "Champagne" },
    { label: "Cognac", value: "Cognac" },
    { label: "Corsica", value: "Corsica" },
    { label: "Jura", value: "Jura" },
    { label: "Languedoc Roussillon", value: "Languedoc Roussillon" },
    { label: "Loire Valley", value: "Loire Valley" },
    { label: "Madiran", value: "Madiran" },
    { label: "Minervois", value: "Minervois" },
    { label: "Pays d'Oc", value: "Pays d'Oc" },
    { label: "Provence", value: "Provence" },
    { label: "Provence-Alpes-Cote d'Azur", value: "Provence-Alpes-Cote d'Azur" },
    { label: "Rhone Valley", value: "Rhone Valley" },
    { label: "Savoie", value: "Savoie" },
    { label: "South West", value: "South West" },
  ],
   Georgia: [
    { label: "Kakheti", value: "Kakheti" },
    { label: "Racha-Lechkhumi", value: "Racha-Lechkhumi" },
  ],
  Italy: [
    { label: "Abruzzo", value: "Abruzzo" },
    { label: "Basilicata", value: "Basilicata" },
    { label: "Calabria", value: "Calabria" },
    { label: "Campania", value: "Campania" },
    { label: "Emilia Romagna", value: "Emilia Romagna" },
    { label: "Friuli Venezia Giulia", value: "Friuli Venezia Giulia" },
    { label: "Garda", value: "Garda" },
    { label: "Lazio", value: "Lazio" },
    { label: "Liguria", value: "Liguria" },
    { label: "Lombardy", value: "Lombardy" },
    { label: "Marche", value: "Marche" },
    { label: "Molise", value: "Molise" },
    { label: "Piedmont", value: "Piedmont" },
    { label: "Puglia", value: "Puglia" },
    { label: "Sardinia", value: "Sardinia" },
    { label: "Sicily", value: "Sicily" },
    { label: "Trentino Alto Adige", value: "Trentino Alto Adige" },
    { label: "Tuscany", value: "Tuscany" },
    { label: "Umbria", value: "Umbria" },
    { label: "Valle d'Aosta", value: "Valle d'Aosta" },
    { label: "Veneto", value: "Veneto" },
  ],
   Japan: [
    { label: "Aichi", value: "Aichi" },
    { label: "Fukuoka", value: "Fukuoka" },
    { label: "Fukushima", value: "Fukushima" },
    { label: "Gifu", value: "Gifu" },
    { label: "Gunma", value: "Gunma" },
    { label: "Hiroshima", value: "Hiroshima" },
    { label: "Hokkaido", value: "Hokkaido" },
    { label: "Hyogo", value: "Hyogo" },
    { label: "Ibaraki", value: "Ibaraki" },
    { label: "Ishikawa", value: "Ishikawa" },
    { label: "Kagoshima", value: "Kagoshima" },
    { label: "Kumamoto", value: "Kumamoto" },
    { label: "Kyoto", value: "Kyoto" },
    { label: "Mie", value: "Mie" },
    { label: "Nagano", value: "Nagano" },
    { label: "Nagasaki", value: "Nagasaki" },
    { label: "Nara", value: "Nara" },
    { label: "Niigata", value: "Niigata" },
    { label: "Oita", value: "Oita" },
    { label: "Okayama", value: "Okayama" },
    { label: "Okinawa", value: "Okinawa" },
    { label: "Osaka", value: "Osaka" },
    { label: "Saga", value: "Saga" },
    { label: "Shimane", value: "Shimane" },
    { label: "Shizuoka", value: "Shizuoka" },
    { label: "Tochigi", value: "Tochigi" },
    { label: "Tonami", value: "Tonami" },
    { label: "Tottori", value: "Tottori" },
    { label: "Yamagata", value: "Yamagata" },
    { label: "Yamaguchi", value: "Yamaguchi" },
  ],
   Mexico: [
    { label: "Durango", value: "Durango" },
    { label: "Guerrero", value: "Guerrero" },
    { label: "Jalisco", value: "Jalisco" },
    { label: "Oaxaca", value: "Oaxaca" },
    { label: "Veracruz", value: "Veracruz" },
  ],
    "New Zealand": [
    { label: "Central Otago", value: "Central Otago" },
    { label: "Hawkes Bay", value: "Hawkes Bay" },
    { label: "Marlborough", value: "Marlborough" },
    { label: "Martinborough", value: "Martinborough" },
    { label: "Nelson", value: "Nelson" },
    { label: "Waipara", value: "Waipara" },
  ],
  Scotland: [
    { label: "Campbeltown", value: "Campbeltown" },
    { label: "Edinburgh", value: "Edinburgh" },
    { label: "Highlands", value: "Highlands" },
    { label: "Islands", value: "Islands" },
    { label: "Islay", value: "Islay" },
    { label: "Lowlands", value: "Lowlands" },
    { label: "Speyside", value: "Speyside" },
  ],
  "South Africa": [
    { label: "Stellenbosch", value: "Stellenbosch" },
    { label: "Western Cape", value: "Western Cape" },
  ],
    Spain: [
    { label: "Alicante", value: "Alicante" },
    { label: "Andalucia", value: "Andalucia" },
    { label: "Aragon", value: "Aragon" },
    { label: "Castilla - La Mancha", value: "Castilla - La Mancha" },
    { label: "Castilla y Leon", value: "Castilla y Leon" },
    { label: "Catalunya", value: "Catalunya" },
    { label: "Extremadura", value: "Extremadura" },
    { label: "Galicia", value: "Galicia" },
    { label: "Jerez", value: "Jerez" },
    { label: "Madrid", value: "Madrid" },
    { label: "Murcia", value: "Murcia" },
    { label: "Navarra", value: "Navarra" },
    { label: "Pais Vasco", value: "Pais Vasco" },
    { label: "Priorat", value: "Priorat" },
    { label: "Ribero del Duero", value: "Ribero del Duero" },
    { label: "Rioja", value: "Rioja" },
    { label: "Valencia", value: "Valencia" },
  ],
    "United States": [
    { label: "Alabama", value: "Alabama" },
    { label: "Arkansas", value: "Arkansas" },
    { label: "California", value: "California" },
    { label: "Colorado", value: "Colorado" },
    { label: "Florida", value: "Florida" },
    { label: "Hawaii", value: "Hawaii" },
    { label: "Idaho", value: "Idaho" },
    { label: "Illinois", value: "Illinois" },
    { label: "Indiana", value: "Indiana" },
    { label: "Iowa", value: "Iowa" },
    { label: "Kentucky", value: "Kentucky" },
    { label: "Maine", value: "Maine" },
    { label: "Michigan", value: "Michigan" },
    { label: "Minnesota", value: "Minnesota" },
    { label: "Missouri", value: "Missouri" },
    { label: "New England", value: "New England" },
    { label: "New Jersey", value: "New Jersey" },
    { label: "New Mexico", value: "New Mexico" },
    { label: "New York", value: "New York" },
    { label: "Ohio", value: "Ohio" },
    { label: "Oregon", value: "Oregon" },
    { label: "Pennsylvania", value: "Pennsylvania" },
    { label: "South Carolina", value: "South Carolina" },
    { label: "Tennessee", value: "Tennessee" },
    { label: "Texas", value: "Texas" },
    { label: "Utah", value: "Utah" },
    { label: "Vermont", value: "Vermont" },
    { label: "Virgin Islands", value: "Virgin Islands" },
    { label: "Virginia", value: "Virginia" },
    { label: "Washington", value: "Washington" },
    { label: "West Virginia", value: "West Virginia" },
    { label: "Wisconsin", value: "Wisconsin" },
    { label: "Wyoming", value: "Wyoming" },
  ],
};

export const SUBREGION_OPTIONS = {
  Aconcagua: [
    { label: "Casablanca", value: "Casablanca" },
    { label: "San Antonio Valley", value: "San Antonio Valley" },
  ],
  "Aconcagua Valley": [
    { label: "San Antonio Valley", value: "San Antonio Valley" },
  ],
  "Central Valley": [
    { label: "Cachapoal", value: "Cachapoal" },
    { label: "Colchagua", value: "Colchagua" },
    { label: "Curico", value: "Curico" },
    { label: "Maipo", value: "Maipo" },
    { label: "Maule", value: "Maule" },
    { label: "Rapel", value: "Rapel" },
  ],
  Coquimbo: [
    { label: "Elqui", value: "Elqui" },
    { label: "Limari", value: "Limari" },
  ],
  Mendoza: [
    { label: "Gualtallary District", value: "Gualtallary District" },
    { label: "Lujan de Cuyo", value: "Lujan de Cuyo" },
    { label: "Lunlunta District", value: "Lunlunta District" },
    { label: "Maipu", value: "Maipu" },
    { label: "Perdriel", value: "Perdriel" },
    { label: "Tupungato", value: "Tupungato" },
    { label: "Uco Valley", value: "Uco Valley" },
  ],
  Patagonia: [
    { label: "Rio Negro", value: "Rio Negro" },
  ],
  Salta: [
    { label: "Cafayate", value: "Cafayate" },
  ],
    Alberta: [
    { label: "Calgary", value: "Calgary" },
    { label: "Edmonton", value: "Edmonton" },
  ],
  "British Columbia": [
    { label: "Naramata", value: "Naramata" },
    { label: "Naramata Bench", value: "Naramata Bench" },
    { label: "Okanagan Falls", value: "Okanagan Falls" },
    { label: "Okanagan Valley", value: "Okanagan Valley" },
    { label: "Oliver", value: "Oliver" },
    { label: "Osoyoos", value: "Osoyoos" },
    { label: "Penticton", value: "Penticton" },
    { label: "Similkameen Valley", value: "Similkameen Valley" },
    { label: "Vancouver", value: "Vancouver" },
  ],
  "Nova Scotia": [
    { label: "Annapolis Valley", value: "Annapolis Valley" },
  ],
  Ontario: [
    { label: "Niagara", value: "Niagara" },
  ],
  "New South Wales": [
    { label: "Hunter Valley", value: "Hunter Valley" },
    { label: "Riverina", value: "Riverina" },
  ],
  "South Australia": [
    { label: "Adelaide", value: "Adelaide" },
    { label: "Barossa", value: "Barossa" },
    { label: "Clare Valley", value: "Clare Valley" },
    { label: "Coonawarra", value: "Coonawarra" },
    { label: "Eden Valley", value: "Eden Valley" },
    { label: "Koonunga", value: "Koonunga" },
    { label: "Langhorne Creek", value: "Langhorne Creek" },
    { label: "Limestone Coast", value: "Limestone Coast" },
    { label: "McLaren Vale", value: "McLaren Vale" },
    { label: "Padthaway", value: "Padthaway" },
  ],
  "South Eastern Australia": [
    { label: "McLaren Vale", value: "McLaren Vale" },
  ],
  Victoria: [
    { label: "Heathcote", value: "Heathcote" },
    { label: "Yarra Valley", value: "Yarra Valley" },
  ],
  "Western Australia": [
    { label: "Frankland River", value: "Frankland River" },
    { label: "Margaret River", value: "Margaret River" },
  ],
  Burgenland: [
    { label: "Eisenberg", value: "Eisenberg" },
    { label: "Neusiedlersee", value: "Neusiedlersee" },
  ],
  Niederosterreich: [
    { label: "Kamptal", value: "Kamptal" },
    { label: "Thermenregion", value: "Thermenregion" },
    { label: "Wachau", value: "Wachau" },
    { label: "Weinviertel", value: "Weinviertel" },
  ],
Bordeaux: [
    { label: "Fronsac", value: "Fronsac" },
    { label: "Graves", value: "Graves" },
    { label: "Haut Medoc", value: "Haut Medoc" },
    { label: "Lalande a Pomerol", value: "Lalande a Pomerol" },
    { label: "Lussac Saint Emilion", value: "Lussac Saint Emilion" },
    { label: "Margaux", value: "Margaux" },
    { label: "Medoc", value: "Medoc" },
    { label: "Mouillac", value: "Mouillac" },
    { label: "Moulis en Medoc", value: "Moulis en Medoc" },
    { label: "Pauillac", value: "Pauillac" },
    { label: "Pessac Leognan", value: "Pessac Leognan" },
    { label: "Pomerol", value: "Pomerol" },
    { label: "Saint-Emilion", value: "Saint-Emilion" },
    { label: "Saint-Estephe", value: "Saint-Estephe" },
    { label: "Saint-Julien", value: "Saint-Julien" },
    { label: "Sauternes & Barsac", value: "Sauternes & Barsac" },
  ],
  Burgundy: [
    { label: "Beaujolais", value: "Beaujolais" },
    { label: "Bourgogne", value: "Bourgogne" },
    { label: "Chablis", value: "Chablis" },
    { label: "Cote Chalonnaise", value: "Cote Chalonnaise" },
    { label: "Cote de Beaune", value: "Cote de Beaune" },
    { label: "Cote de Nuits", value: "Cote de Nuits" },
    { label: "Fixin", value: "Fixin" },
    { label: "Maconnais", value: "Maconnais" },
    { label: "Pommard", value: "Pommard" },
  ],
  Jura: [
    { label: "Arbois", value: "Arbois" },
  ],
  "Languedoc Roussillon": [
    { label: "Corbieres", value: "Corbieres" },
    { label: "Limoux", value: "Limoux" },
  ],
  "Loire Valley": [
    { label: "Nantais", value: "Nantais" },
    { label: "Pouilly Fume", value: "Pouilly Fume" },
    { label: "Sancerre", value: "Sancerre" },
    { label: "Saumur", value: "Saumur" },
    { label: "Saumur-Champigny", value: "Saumur-Champigny" },
    { label: "Touraine", value: "Touraine" },
    { label: "Vouvray", value: "Vouvray" },
  ],
  Provence: [
    { label: "Cotes de Provence", value: "Cotes de Provence" },
    { label: "Luberon", value: "Luberon" },
  ],
  "Rhone Valley": [
    { label: "Chateauneuf du Pape", value: "Chateauneuf du Pape" },
    { label: "Cornas", value: "Cornas" },
    { label: "Costieres de Nimes", value: "Costieres de Nimes" },
    { label: "Cote Rotie", value: "Cote Rotie" },
    { label: "Crozes-Hermitage", value: "Crozes-Hermitage" },
    { label: "Gigondas", value: "Gigondas" },
    { label: "Hermitage", value: "Hermitage" },
    { label: "Saint-Joseph", value: "Saint-Joseph" },
    { label: "Vacqueyras", value: "Vacqueyras" },
  ],
   Basilicata: [
    { label: "Vulture", value: "Vulture" },
  ],
  Campania: [
    { label: "Avellino", value: "Avellino" },
  ],
  Lombardy: [
    { label: "Franciacorta", value: "Franciacorta" },
    { label: "Pavia", value: "Pavia" },
  ],
  Piedmont: [
    { label: "Alba", value: "Alba" },
    { label: "Asti", value: "Asti" },
    { label: "Barbaresco", value: "Barbaresco" },
    { label: "Barolo", value: "Barolo" },
    { label: "Bussia", value: "Bussia" },
    { label: "Canelli", value: "Canelli" },
    { label: "Gattinara", value: "Gattinara" },
    { label: "Gavi", value: "Gavi" },
    { label: "Langhe", value: "Langhe" },
    { label: "Roero", value: "Roero" },
    { label: "Serralunga d'Alba", value: "Serralunga d'Alba" },
  ],
  Puglia: [
    { label: "Castel del Monte", value: "Castel del Monte" },
    { label: "Salento", value: "Salento" },
  ],
  Sicily: [
    { label: "Etna", value: "Etna" },
    { label: "Menfi", value: "Menfi" },
  ],
  "Trentino Alto Adige": [
    { label: "Sudtirol", value: "Sudtirol" },
  ],
  Tuscany: [
    { label: "Bolgheri", value: "Bolgheri" },
    { label: "Chianti", value: "Chianti" },
    { label: "Maremma", value: "Maremma" },
    { label: "Montalcino", value: "Montalcino" },
    { label: "Montepulciano", value: "Montepulciano" },
  ],
  Umbria: [
    { label: "Orvieto", value: "Orvieto" },
  ],
  Veneto: [
    { label: "Bardolino", value: "Bardolino" },
    { label: "Breganze", value: "Breganze" },
    { label: "Conegliano Valdobbiadene", value: "Conegliano Valdobbiadene" },
    { label: "Treviso", value: "Treviso" },
    { label: "Valpolicella", value: "Valpolicella" },
  ],
    Marlborough: [
    { label: "Wairau Valley", value: "Wairau Valley" },
  ],
  Andalucia: [
    { label: "Sierras de Malaga", value: "Sierras de Malaga" },
  ],
  Aragon: [
    { label: "Calatayud", value: "Calatayud" },
    { label: "Campo de Borja", value: "Campo de Borja" },
    { label: "Carinena", value: "Carinena" },
  ],
  "Castilla - La Mancha": [
    { label: "Jumilla", value: "Jumilla" },
    { label: "Toro", value: "Toro" },
  ],
  "Castilla y Leon": [
    { label: "Bierzo", value: "Bierzo" },
    { label: "Cigales", value: "Cigales" },
    { label: "Ribera del Duero", value: "Ribera del Duero" },
    { label: "Rueda", value: "Rueda" },
    { label: "Toro", value: "Toro" },
  ],
  Catalunya: [
    { label: "Monsant", value: "Monsant" },
    { label: "Penedes", value: "Penedes" },
    { label: "Priorat", value: "Priorat" },
    { label: "Tarragona", value: "Tarragona" },
  ],
  Extremadura: [
    { label: "Ribera del Guadiana", value: "Ribera del Guadiana" },
  ],
  Galicia: [
    { label: "Rias Baixas", value: "Rias Baixas" },
    { label: "Ribeiro", value: "Ribeiro" },
  ],
  Madrid: [
    { label: "Rueda", value: "Rueda" },
  ],
  Murcia: [
    { label: "Jumilla", value: "Jumilla" },
    { label: "Yecla", value: "Yecla" },
  ],
  "Pais Vasco": [
    { label: "Txakolina", value: "Txakolina" },
  ],
  Valencia: [
    { label: "Alicante", value: "Alicante" },
  ],
   California: [
    { label: "Alexander Valley", value: "Alexander Valley" },
    { label: "Carneros", value: "Carneros" },
    { label: "Central Coast", value: "Central Coast" },
    { label: "Coombsville", value: "Coombsville" },
    { label: "Diamond Mountain District", value: "Diamond Mountain District" },
    { label: "Dry Creek Valley", value: "Dry Creek Valley" },
    { label: "Edna Valley", value: "Edna Valley" },
    { label: "Howell Mountain", value: "Howell Mountain" },
    { label: "Knights Valley", value: "Knights Valley" },
    { label: "Lodi", value: "Lodi" },
    { label: "Mendocino County", value: "Mendocino County" },
    { label: "Monterey", value: "Monterey" },
    { label: "Napa Valley", value: "Napa Valley" },
    { label: "North Coast", value: "North Coast" },
    { label: "Oakville", value: "Oakville" },
    { label: "Paso Robles", value: "Paso Robles" },
    { label: "Russian River", value: "Russian River" },
    { label: "Rutherford", value: "Rutherford" },
    { label: "Santa Barbara County", value: "Santa Barbara County" },
    { label: "Santa Cruz Mountains", value: "Santa Cruz Mountains" },
    { label: "Santa Lucia", value: "Santa Lucia" },
    { label: "Santa Lucia Highlands", value: "Santa Lucia Highlands" },
    { label: "Santa Maria Valley", value: "Santa Maria Valley" },
    { label: "Santa Rita Hills", value: "Santa Rita Hills" },
    { label: "Santa Ynez Valley", value: "Santa Ynez Valley" },
    { label: "Sierra Foothills", value: "Sierra Foothills" },
    { label: "Sonoma", value: "Sonoma" },
    { label: "Sonoma Coast", value: "Sonoma Coast" },
    { label: "Sonoma County", value: "Sonoma County" },
    { label: "Spring Mountain", value: "Spring Mountain" },
    { label: "Stags Leap District", value: "Stags Leap District" },
  ],
  Oregon: [
    { label: "Applegate Valley", value: "Applegate Valley" },
    { label: "Chehalem Mountains", value: "Chehalem Mountains" },
    { label: "Columbia Valley", value: "Columbia Valley" },
    { label: "Dundee Hills", value: "Dundee Hills" },
    { label: "Eola-Amity Hills", value: "Eola-Amity Hills" },
    { label: "Rogue Valley", value: "Rogue Valley" },
    { label: "Walla Walla", value: "Walla Walla" },
    { label: "Willamette Valley", value: "Willamette Valley" },
    { label: "Yamhill-Carlton", value: "Yamhill-Carlton" },
  ],
  Washington: [
    { label: "Columbia Valley", value: "Columbia Valley" },
    { label: "Horse Heaven Hills", value: "Horse Heaven Hills" },
    { label: "Puget Sound", value: "Puget Sound" },
    { label: "Red Mountain", value: "Red Mountain" },
    { label: "Wahluke Slope", value: "Wahluke Slope" },
    { label: "Walla Walla", value: "Walla Walla" },
    { label: "Yakima Valley", value: "Yakima Valley" },
  ],
  "Sonoma Valley": [
    { label: "Alexander Valley", value: "Alexander Valley" },
  ],
};